export default __webpack_public_path__ + "static/castform-db1918146931d7bed31b33b03c8dffd8.png";